import React, { forwardRef } from 'react';

/**
 * Renders user-authored or backend-localized business data without allowing the
 * transitional legacy translation bridge to rewrite it.
 */
const RawText = forwardRef(function RawText(
  { as: Component = 'span', children, ...props },
  ref,
) {
  return (
    <Component
      {...props}
      ref={ref}
      translate="no"
      data-i18n-skip="true"
    >
      {children}
    </Component>
  );
});

export default RawText;
